import styles from "./OnboardingMarquee.module.scss";
import { marqueeImages } from "../../../assets/tenant";
import Marquee from "react-fast-marquee";

const items = marqueeImages.map((src) => ({ src }));

export const OnboardingMarquee = () => {
  return (
    <Marquee className={styles.marqueeContainer}>
      {items.map((item, index) => (
        <img src={item.src} key={index} alt="" />
      ))}
    </Marquee>
  );
};
